import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import WelcomeOne from '../../components/section-components/WelcomeOne';
import AwardOne from '../../components/section-components/AwardOne';
import Experiences from '../../components/section-components/Experiences';
import PracticeAreasOne from '../../components/section-components/PracticeAreasOne';
import OurAttorneysOne from '../../components/section-components/OurAttorneysOne';
import Counter from '../../components/section-components/Counter';
import FooterOne from '../../common/footer/FooterOne';

const AboutUsOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="About Us 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="About Us 1"
        />
        
        <WelcomeOne />
        
        <AwardOne /> 
        
        <Experiences />
        
        <PracticeAreasOne />
        
        <OurAttorneysOne />
        
        <Counter />

        <FooterOne />
        </>
    )
}
    
export default AboutUsOne;